import { createPermission } from '@backstage/plugin-permission-common';

/**
 * Permission to access the maturity review plugin
 */
export const maturityReviewAccessPermission = createPermission({
  name: 'maturity.review.access',
  attributes: {
    action: 'read',
  },
});

/**
 * All maturity review permissions
 */
export const maturityReviewPermissions = [maturityReviewAccessPermission];
